module.exports = __webpack_public_path__ + "static/media/number-health.7583c5af.svg";